import {translate} from 'iss/strings';
import {translatePartyActivationType} from 'iss/widgets/domainTranslations';

export function formatParty({firstname, lastname, email}, style = "full") {
  const hasName = firstname && lastname;
  if (hasName) {
    if (style === "full" && email) {
      return `${firstname} ${lastname} (${email})`;
    } if (style === "full" && !email) {
      return `${firstname} ${lastname} (${translate("party.hasNoEmail")})`;
    } else {
      return `${firstname} ${lastname}`;
    }
  } else {
    return email;
  }
}

export function formatActivationParty(party) {
  return translatePartyActivationType(party.activationType)+": "+formatParty(party);
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/format/Party.js